import React from 'react';

const SpeechBubble = ({ 
  children, 
  direction = 'left', 
  className = '', 
  // Added props to handle dynamic coloring of the bubble and its tail
  variant = 'white' 
}) => {
  const bgColors = {
    white: 'bg-white',
    dark: 'bg-hcf-dark',
    purple: 'bg-hcf-purple',
    pink: 'bg-hcf-pink',
    cyan: 'bg-hcf-cyan',
    yellow: 'bg-hcf-yellow'
  };

  const tailColors = {
    white: 'border-t-white',
    dark: 'border-t-hcf-dark',
    purple: 'border-t-hcf-purple',
    pink: 'border-t-hcf-pink',
    cyan: 'border-t-hcf-cyan',
    yellow: 'border-t-hcf-yellow'
  };

  const bgColor = bgColors[variant] || bgColors.white;
  const tailColor = tailColors[variant] || tailColors.white;

  const tailClass = direction === 'left' 
    ? 'bottom-[-20px] left-[20px] border-l-[20px] border-r-[20px] border-t-[20px] border-l-transparent border-r-transparent border-t-black' 
    : 'bottom-[-20px] right-[20px] border-l-[20px] border-r-[20px] border-t-[20px] border-l-transparent border-r-transparent border-t-black';
  
  const innerTailClass = direction === 'left' 
    ? `bottom-[-12px] left-[24px] border-l-[16px] border-r-[16px] border-t-[16px] border-l-transparent border-r-transparent ${tailColor}` 
    : `bottom-[-12px] right-[24px] border-l-[16px] border-r-[16px] border-t-[16px] border-l-transparent border-r-transparent ${tailColor}`;

  return (
    <div className={`relative ${bgColor} border-4 border-black p-8 rounded-[2rem] mb-12 shadow-comic ${className}`}>
      <div className="font-comic text-xl leading-relaxed text-center">
        {children}
      </div>
      {/* Tail Border */}
      <div className={`absolute w-0 h-0 ${tailClass}`}></div>
      {/* Tail Fill */}
      <div className={`absolute w-0 h-0 ${innerTailClass}`}></div>
    </div>
  );
};

export default SpeechBubble;